import axios from "axios";

export const switchCourseState = (courseId, data, callback) => {
  var promise = axios({
    method: "patch",
    url: `/api/courses/${courseId}/switch_state`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const duplicateCourseAPI = async (courseId) => {
  try {
    const response = await axios({
      method: "post",
      url: `/api/courses/${courseId}/duplicate_course`,
      headers: {
        "X-CSRF-TOKEN": window.Hupe8.token
      }
    });
    return response;
  } catch (err) {
    console.error("Error duplicando curso:", err);
    throw err;
  }
};

export const grantHeadAccessAPI = async (courseId) => {
  return axios({
    method: "post",
    url: `/api/courses/${courseId}/grant_head_access`,
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  });
};

export const activatePublicationAPI = (publicationId, callback) => {
  const formData = new FormData();
  formData.append("publication_basis[action]", "activate");
  
  var promise = axios({
    method: "put",
    url: `/api/publication_bases/${publicationId}/switch_state`,
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};